import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, Tab } from '@heroui/react';
import { PageHeader } from '@/components/common/PageHeader';
import { ProfileSection } from '@/pages/settings/ProfileSection';
import { SecuritySection } from '@/pages/settings/SecuritySection';
import { SessionSection } from '@/pages/settings/SessionSection';

const SECTIONS = ['profile', 'security', 'sessions'] as const;

/** Settings shell — section is a real URL segment (/settings/:section). */
export function SettingsPage() {
  const { section = 'profile' } = useParams();
  const navigate = useNavigate();
  const active = (SECTIONS as readonly string[]).includes(section) ? section : 'profile';

  return (
    <div>
      <PageHeader title="Settings" description="Manage your profile, security and sessions." />
      <Tabs
        aria-label="Settings sections"
        variant="underlined"
        color="primary"
        selectedKey={active}
        onSelectionChange={(k) => navigate(`/settings/${k}`)}
      >
        <Tab key="profile" title="Profile"><div className="pt-4"><ProfileSection /></div></Tab>
        <Tab key="security" title="Security"><div className="pt-4"><SecuritySection /></div></Tab>
        <Tab key="sessions" title="Sessions"><div className="pt-4"><SessionSection /></div></Tab>
      </Tabs>
    </div>
  );
}
